// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transport[data-v-46d43e8e] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
